import type { LoggerOptions } from 'pino';
import { traceLogMixin } from '@/utils/trace-log';

/**
 * Shared Pino logger configuration for browser environment
 * Used by both the Nuxt plugin and standalone instances (e.g., cancelable-promise.ts)
 */
export const pinoConfig: LoggerOptions = {
  browser: {
    asObject: true,
    // active な OTel span の trace_id/span_id を各ログへ付与する (設計 05 §3.2 / 07 §3.3)。
    // pino の browser ビルドは `mixin` 非対応のため formatters.log で付与する。
    formatters: {
      log: (logObject) => ({ ...logObject, ...traceLogMixin() }),
    },
  },
  level: process.env.NODE_ENV === 'production' ? 'info' : 'debug',
};
